import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "negotiable-quote-b2b-interfaces"
    }}>{`Negotiable quote (B2B) interfaces`}</h1>
    <p>{`Negotiable quote queries and mutations can access the following interfaces:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-NegotiableQuoteAddressInterface"
          }}><inlineCode parentName="a">{`NegotiableQuoteAddressInterface`}</inlineCode></a>{`. It is implemented by `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-NegotiableQuoteShippingAddress"
          }}><inlineCode parentName="a">{`NegotiableQuoteShippingAddress`}</inlineCode></a>{` and  `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-NegotiableQuoteBillingAddress"
          }}><inlineCode parentName="a">{`NegotiableQuoteBillingAddress`}</inlineCode></a>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-NegotiableQuoteUidNonFatalResultInterface"
          }}><inlineCode parentName="a">{`NegotiableQuoteUidNonFatalResultInterface`}</inlineCode></a>{`. It is implemented by `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-NegotiableQuoteUidOperationSuccess"
          }}><inlineCode parentName="a">{`NegotiableQuoteUidOperationSuccess`}</inlineCode></a>{`.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      